export const camelCaseToKebabCase = (arg) => arg.replace(/([a-z0-9]|(?=[A-Z]))([A-Z0-9])/g, "$1-$2").toLowerCase();
export const modifier = (arg) => Object.entries(arg).map(([key, value]) => value ? camelCaseToKebabCase(key) : "");
